import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { reservasAPI, cobranzasAPI } from "../../../utils/funcionesAPI";
import { manejadorDeRespuesta } from "../../../utils/Tools";
import CuadroResumen from "../CuadroResumen";
import LoaderFormal from "../../Global/LoaderFormal";
import { toast, ToastContainer } from "react-toastify";
import TarjetasBancoCuotasPedraza from "../../Global/TarjetasBancoCuotasPedraza";
import TotalConTarjeta from "../../Global/TotalConTarjeta";

import check from "../../../imagenes/thanks/check.png";
import check2x from "../../../imagenes/thanks/check@2x.png";
import cruz from "../../../imagenes/thanks/cruz.png";
import cruz2x from "../../../imagenes/thanks/cruz@2x.png";
import imgSmall from "../../../imagenes/sobrePedraza/img-small-2.png";
import imgSmall2x from "../../../imagenes/sobrePedraza/img-small-2@2x.png";
import NumberFormat from 'react-number-format';

const FirstData = (props) => {
  const [reserva, setReserva] = useState({
    charter: {},
    producto: {
      destino: {},
      moneda: {
        cotizacion: 1,
        codigoMoneda: "PES",
      },
    },
  });
  const [importe, setImporte] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [tarjetaElegida, setTarjetaElegida] = useState({ id: 0 });
  const [cuotaElegida, setCuotaElegida] = useState({
    id: 0,
    cantidad: 0,
    interes: 0,
  });
  const [bancoElegido, setBancoElegido] = useState({});
  const [importeProporcionalRGPais, setImporteProporcionalRGPais] = useState(0);
  //const [idBancoElegido, setIdBancoElegido] = useState(0);
  const [errorFirstData, setErrorFirstData] = useState('');

  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");

  if (!token && !user) {
    props.history.push("/login");
  }

  const estado = props.match.params.estado;
  useEffect(() => {
    if (estado === 'success') {
      toast.info(
        "Aguarde unos instantes y será redirigido al panel de Mis Reservas.",
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 8000,
          onClose: () => {
            window.location.href = "https://pedraza.com.ar/panel-mis-reservas";
            return null;
          },
        }
      );
    } else {
      const data = JSON.stringify({
        peticion: "traerMensajeErrorFirstData",
        numeroReserva: props.match.params.nroReserva
      });
      cobranzasAPI(data).then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          setErrorFirstData(`: ${respuesta.data}`);
        }
      });
    }
  }, [estado]);

  const traerReservaPorNumero = (numeroReserva) => {
    const data = JSON.stringify({
      peticion: "traerReservaPorNumero",
      token: token,
      numeroReserva,
    });
    setLoaded(true);
    reservasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) setLoaded(false);
      setReserva(respuesta.data);
      setImporte(Math.ceil(respuesta.data.saldo * respuesta.data.producto.moneda.cotizacion));
    });
  };

  useEffect(() => {
    traerReservaPorNumero(props.match.params.nroReserva);
  }, [props.match.params.nroReserva]);

  const handleTarjetaClick = (tarjetaEleg, cuotaElegida) => {
    setTarjetaElegida(tarjetaEleg);
    setCuotaElegida(cuotaElegida);
  };

  const handleBancoClick = (banco) => {
    setBancoElegido(banco);
  };
  /*
  const handleBancoClick = (idBancoElegido) => {
    setIdBancoElegido(idBancoElegido);
  };
*/
  const handleCuotaClick = (cuotaEleg) => {
    setCuotaElegida(cuotaEleg);
  };

  const handlePagoChange = (e) => {
    if (e.target.value === '') return;
    const numberWithoutDot = e.target.value.replaceAll(',','');
    setImporte(numberWithoutDot);
    handleRecalcularProporcionalImpuesto(numberWithoutDot);
  };

  const handleRecalcularProporcionalImpuesto = (importe) => {
    if (reserva.producto.impuestoPAIS.coeficiente === 0) {
      const coefTasa =
        1 -
        reserva.charter.tarifa.importeNoComisionable /
          reserva.charter.tarifa.tarifa;
      const coefRG = reserva.producto.impuestoPAIS.valor / 100;
      const coefBaseImponible = 1; //forzado
      const coefAplicacion =
        parseFloat(coefTasa.toFixed(6)) * coefRG * coefBaseImponible;
      const coefAplicar = 1 + coefAplicacion;
      //importeQuePaga = Es el importe que tipea el cliente que quiere pagar. No menos del 30% del total del viaje

      //ProcentajePais = Es el porcentaje de la RG que se debe aplicar obtenida del query
      //const infoas = despejarInfoas(this.props.pasajerosMenores);//function en Tools
      //const pasajerosPagantes = this.props.pasajerosAdultos.length + this.props.pasajerosMenores.length - infoas;

      const importeProporcionalRGPais = importe - importe / coefAplicar;

      //const importeRGPaisPQ = importeRGPaisCL / cot_PQ;//  (por si necestias tener el valor en moneda del Paquete)
      //Este importe importeRGPaisCL  es que se suma al importeQuePaga y es el que viaja a FirstData
      //const importeFirstFData =  this.state.importeAPagarConImpuestosYIntereses + importeProporcionalRGPais;
      setImporteProporcionalRGPais(importeProporcionalRGPais);
    }
  };

  const handlePagarConFirstDataClick = (e) => {
    e.preventDefault();

    if (!importe) {
      toast.info("Debe ingresar un importe.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (
      !bancoElegido.id ||
      !tarjetaElegida.id ||
      !cuotaElegida.cantidad
    ) {
      toast.info("Debe seleccionar tarjeta, banco y plan de cuotas", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    /*if (parseFloat(importe) > parseFloat(reserva.saldo)) {
        toast.info("El importe no debe superar al saldo de la reserva.", {
                            position: toast.POSITION.BOTTOM_CENTER
                            });
        return;
      }*/

    const pagoElectronico = {
      numeroReserva: reserva.numeroReserva,
      canal: "WEB",
      totalPagar: importe,
      tarjetaElegida,
      cuotaElegida,
      bancoElegido,
      producto: reserva.producto
    };

    const data = JSON.stringify({
      peticion: "firstData",
      //reserva,
      //importe,
      token,
      //cuotaElegida,
      //tarjetaElegida,
      //bancoElegido,
      pagoElectronico
      //idBancoElegido: idBancoElegido,
    });

    setLoaded(true);
    toast.info(
      "Aguarde unos segundos mientras es dirigido al sistema de cobro con Tarjeta de Crédito.",
      {
        position: toast.POSITION.BOTTOM_CENTER,
      }
    );
    cobranzasAPI(data).then((respuesta) => {
      setLoaded(false);
      if (manejadorDeRespuesta(props, respuesta)) {
        return (window.location.href = respuesta.data);
      }
    });
  };

  const mostrarMensajeResultado = (estadoElegido) => {
    let mensaje = "";
    switch (estadoElegido) {
      case "success":
        mensaje = (
          <span className="textoConfirmada">
            El Pago ha sido procesado. En la proximas horas su saldo será
            actualizado.
          </span>
        );
        break;
      case "error":
        mensaje = (
          <span className="textoCancelada">
            Ha ocurrido un error durante el pago{errorFirstData}
          </span>
        );
        break;
      case "pending":
        mensaje = (
          <span className="textoCancelada">
            El pago se encuentra en estado pendiente.
          </span>
        );
        break;
      default:
        break;
    }

    return mensaje;
  };

  return (
    <section className="reservas">
      <div className="container-fluid">
        <div className="row">
          <LoaderFormal loaded={loaded} />
          <h1>Pagar con Tarjeta de Crédito</h1>
          <hr />
          {/*MENSAJE DE FEEDBACK CUANDO PAGO CON TARJETA */}
          {estado ? (
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 thanks clearfix">
              {estado === "success" ? (
                <img
                  src={check}
                  alt="Icono de un check"
                  srcSet={check + " 1x, " + check2x + " 2x"}
                />
              ) : (
                <img
                  src={cruz}
                  alt="Icono de un check"
                  srcSet={cruz + " 1x, " + cruz2x + " 2x"}
                />
              )}
              <h2
                className={
                  estado === "success" ? "mensajeExito" : "mensajeError"
                }
              >
                Pago {estado === "success" ? "Exitoso" : "Rechazado"}
              </h2>
              <div className="compra-resumen" style={{ margin: "35px auto" }}>
                <div className="img-container">
                  <img
                    src={imgSmall}
                    alt="Imagen de fondo acerca de viajes"
                    srcSet={imgSmall + " 1x, " + imgSmall2x + " 2x"}
                  />
                </div>
                <div className="txt-container">
                  <h3>{mostrarMensajeResultado(estado)}</h3>
                </div>
              </div>
            </div>
          ) : null}

          <CuadroResumen reserva={reserva} />
          <div className="content col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div>
              <form className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <p>
                  {/* estado ? <span>{this.mostrarMensajeResultado(estado)}</span> : null */}
                </p>
                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="importe">
                    Ingresar Importe (usar el punto "." para ingresar decimales)
                  </label>
                  <NumberFormat 
                    value={importe} 
                    className="form-control"
                    name="importe"
                    displayType={'input'} 
                    thousandSeparator=','
                    allowNegative={false}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    decimalSeparator='.'
                    onChange={handlePagoChange}
                  />
                 {/*  <input
                    className="form-control"
                    type="number"
                    name="importe"
                    placeholder="Importe"
                    required
                    value={importe}
                    onChange={handlePagoChange}
                  /> */}
                  <TarjetasBancoCuotasPedraza
                    cuotaElegida={cuotaElegida}
                    tarjetaElegida={tarjetaElegida}
                    onTarjetaClick={handleTarjetaClick}
                    onBancoClick={handleBancoClick}
                    onCuotaClick={handleCuotaClick}
                    producto={reserva.producto}
                  />
                </div>

                <section className="checkout-steps">
                  <div className="container">
                    <div className="row">
                      <div className="content col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12">
                        <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 payment clearfix">
                          <TotalConTarjeta
                            cuotaElegida={cuotaElegida}
                            totalPaquete={
                              reserva.saldo * reserva.producto.moneda.cotizacion
                            }
                            impuestoPais="0"
                            importeAPagar={importe}
                            importeProporcionalRGPais={
                              importeProporcionalRGPais
                            }
                          />
                        </section>
                      </div>
                    </div>
                  </div>
                </section>

                <p className="contenedorLinkInicio col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                  <input
                    className="botonInicio"
                    type="submit"
                    value="Pagar"
                    onClick={handlePagarConFirstDataClick}
                  />
                </p>
              </form>
            </div>
            <div className="listado">
              <Link to="/panel-mis-reservas">Volver al Panel</Link>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default FirstData;

/*
<div className="contenedorLinkInicio col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" style={{backgroundColor: '#d8d8d8', padding: '10px'}}>
  <p>Subtotal: $ {this.state.importe}</p>
  <p>Intereses: $ {this.state.importe * (this.state.cuotaElegida.interes / 100)}</p>
  <hr />
  <p><strong>Total: $ {parseFloat(this.state.importe) + parseFloat(this.state.importe * (this.state.cuotaElegida.interes / 100))}</strong></p>
</div>


*/



// WEBPACK FOOTER //
// ./src/components/MisReservas/FirstData/index.js